import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize'
})
export class StorageFileSizePipe implements PipeTransform {

    /**
     * Transforms a number of bytes into a human-readable file size string (KB, MB, GB, TB).
     * @param bytes The file size in bytes.
     * @param decimals The number of decimal places to display (default is 2).
     * @returns A formatted string (e.g., "1.25 MB").
     */
    transform(bytes: number | null | undefined, decimals: number = 2): string {
        if (bytes === 0 || bytes === null || bytes === undefined) {
            return '0 Bytes';
        }

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        // Calculate the index of the appropriate size unit (0 for Bytes, 1 for KB, etc.)
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        // Return the formatted number followed by the unit (e.g., MB)
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + units[i];
    }

}